import request from '@/utils/request'
const BASE_URL = '/Option'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(id) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data: { id }
    })
  },
  numericSettingSave(data) {
    return request({
      url: BASE_URL + '/NumericSettingSave',
      method: 'post',
      data
    })
  },
  productSettingSave(data) {
    return request({
      url: BASE_URL + '/ProductSettingSave',
      method: 'post',
      data
    })
  },
  saleSettingSave(data) {
    return request({
      url: BASE_URL + '/SaleSettingSave',
      method: 'post',
      data
    })
  },
  getNumericSetting() {
    return request({
      url: BASE_URL + '/GetNumericSetting',
      method: 'get',
    })
  },
  getProductSetting() {
    return request({
      url: BASE_URL + '/GetProductSetting',
      method: 'get',
    })
  },
  getSaleSetting() {
    return request({
      url: BASE_URL + '/GetSaleSetting',
      method: 'get',
    })
  },
  valuationSettingSave(data) {
    return request({
      url: BASE_URL + '/ValuationSettingSave',
      method: 'post',
      data
    })
  },
  getValuationSetting() {
    return request({
      url: BASE_URL + '/GetValuationSetting',
      method: 'get',
    })
  },
  docSettingSave(data) {
    return request({
      url: BASE_URL + '/DocSettingSave',
      method: 'post',
      data
    })
  },
  getDocSetting(data) {
    return request({
      url: BASE_URL + '/GetDocSetting',
      method: 'get',
    })
  },
  purchaseSettingSave(data) {
    return request({
      url: BASE_URL + '/PurchaseSettingSave',
      method: 'post',
      data
    })
  },
  getPurchaseSetting() {
    return request({
      url: BASE_URL + '/GetPurchaseSetting',
      method: 'get',
    })
  },
  getWorkDocSetting() {
    return request({
      url: BASE_URL + '/GetWorkDocSetting',
      method: 'get',
    })
  },
  stockSettingSave(data) {
    return request({
      url: BASE_URL + '/StockSettingSave',
      method: 'post',
      data
    })
  },
  getStockSetting() {
    return request({
      url: BASE_URL + '/GetStockSetting',
      method: 'get',
    })
  },
  getSysWebSetting(){
    return request({
      url: BASE_URL + '/GetSysWebSetting',
      method: 'get',
    })
  },
  initialSettingSave(data) {
    return request({
      url: BASE_URL + '/InitialSettingSave',
      method: 'post',
      data
    })
  },
  workDocSettingSave(data) {
    return request({
      url: BASE_URL + '/WorkDocSettingSave',
      method: 'post',
      data
    })
  },
  getInitialSetting() {
    return request({
      url: BASE_URL + '/GetInitialSetting',
      method: 'get',
    })
  },
  getSaleCheckSetting() {
    return request({
      url: BASE_URL + '/GetSaleCheckSetting',
      method: 'get',
    })
  },
  saleCheckSettingSave(data) {
    return request({
      url: BASE_URL + '/SaleCheckSettingSave',
      method: 'post',
      data
    })
  },
}